import { KeenSliderHooks, KeenSliderInstance, useKeenSlider } from 'keen-slider/react';
import React, { MutableRefObject, PropsWithChildren, useEffect, useMemo } from 'react';
import { CarouselOptions } from './types';
import { ThumbnailPlugin } from './utils';
interface Props extends PropsWithChildren {
  sliderInstanceRef: MutableRefObject<KeenSliderInstance<object, object, KeenSliderHooks> | null>;
  thumbnailOptions?: CarouselOptions;
}
const ThumbnailCarousel = ({
  sliderInstanceRef,
  thumbnailOptions,
  children
}: Props) => {
  const sliderConfig = useMemo(() => ({
    initial: 0,
    mode: thumbnailOptions?.mode || 'snap',
    slides: {
      perView: thumbnailOptions?.perView || 4,
      spacing: thumbnailOptions?.spacing || 8
    },
    rtl: true
  }), [thumbnailOptions?.mode, thumbnailOptions?.perView, thumbnailOptions?.spacing]);
  const [thumbnailRef, instanceRef] = useKeenSlider<HTMLDivElement>(sliderConfig, [ThumbnailPlugin(sliderInstanceRef)]);
  useEffect(() => {
    instanceRef.current?.update(sliderConfig);
  }, [instanceRef, sliderConfig, children]);
  return <div ref={thumbnailRef} className='keen-slider thumbnail' data-sentry-component="ThumbnailCarousel" data-sentry-source-file="thumbnail-carousel.tsx">
            {children}
        </div>;
};
export default ThumbnailCarousel;